import { HrmActions } from "../../pages/components/hrm_actions";

export const loginLogsColumns = ({ onSelectAction }) => {
  return [
    {
      Header: "Sr. No.",
      accessor: "idd", // Assuming you set 'idd' correctly in the data
      Cell: ({ row }) => {
        return row.original.idd; // Return the idd value
      },
    },
    {
      Header: "Email",
      accessor: (row) => {
        return row?.email || "N/A";
      },
    },
    {
      Header: "Date",
      accessor: (row) => {
        return row?.date || "N/A";
      },
    },
    {
      Header: "Time",
      accessor: (row) => {
        if (!row?.time) return "N/A";

        let [hours, minutes, seconds] = row.time.split(":");
        hours = parseInt(hours, 10);

        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12; // convert 0 -> 12 and 13 -> 1

        return `${hours}:${minutes} ${ampm}`;
      },
    },
    // {
    //   Header: "Actions",
    //   accessor: (row) => {
    //     return (
    //       <div className="text-left">
    //         <HrmActions
    //           onSelectAction={onSelectAction}
    //           row={row}
    //           isDelete={true}
    //         />
    //       </div>
    //     );
    //   },
    // },
  ];
};
